

// import johnMaesaka from "../../assets/Pannel Members/john.jpg";
// import consolatoSergi from "../../assets/Pannel Members/consolato.jpg";
// import saadTayyab from "../../assets/Pannel Members/saad.jpg";
// import berndBlobel from "../../assets/Pannel Members/bernd.jpg";
// import murrayMooYoung from "../../assets/Pannel Members/murray.jpg";
// import valasiaIakovoglou from "../../assets/Pannel Members/valasia.jpg";
// import vladlenSlepak from "../../assets/Pannel Members/vladlen.jpg";
// import yongXiaoWang from "../../assets/Pannel Members/yong.jpg";

// import johnMaesaka_banner from "../../assets/Pannel Banners/john_banner.jpg";
// import consolatoSergi_banner from "../../assets/Pannel Banners/consolato_banner.jpg";
// import saadTayyab_banner from "../../assets/Pannel Banners/saad_banner.jpg";
// import berndBlobel_banner from "../../assets/Pannel Banners/bernd_banner.jpg";
// import murrayMooYoung_banner from "../../assets/Pannel Banners/murray_banner.jpg";
// import valasiaIakovoglou_banner from "../../assets/Pannel Banners/valasia_banner.jpg";
// import vladlenSlepak_banner from "../../assets/Pannel Banners/vladlen_banner.jpg";
// import yongXiaoWang_banner from "../../assets/Pannel Banners/yong_banner.jpg";

// export const panel_members_about = [
//   {
//     id: "john-maesaka",
//     image: johnMaesaka,
//     name: "Dr. John K. Maesaka",
//     from: "USA",
//     about: "NYU Grossman Long Island School of Medicine",
//     link: "/executive-panel-members/john-maesaka",
//   },
//   {
//     id: "consolato-sergi",
//     image: consolatoSergi,
//     name: "Dr. Consolato Sergi",
//     from: "Canada",
//     about: "University of Alberta and Ottawa",
//     link: "/executive-panel-members/consolato-sergi",
//   },
//   {
//     id: "saad-tayyab",
//     image: saadTayyab,
//     name: "Dr. Saad Tayyab",
//     from: "Malaysia",
//     about: "UCSI University, Kuala Lumpur",
//     link: "/executive-panel-members/saad-tayyab",
//   },
//   {
//     id: "bernd-blobel",
//     image: berndBlobel,
//     name: "Dr. Bernd Blobel",
//     from: "Germany",
//     about: "University of Magdeburg",
//     link: "/executive-panel-members/bernd-blobel",
//   },
//   {
//     id: "murray-moo-young",
//     image: murrayMooYoung,
//     name: "Prof. Murray Moo-Young",
//     from: "Canada",
//     about: "University of Waterloo",
//     link: "/executive-panel-members/murray-moo-young",
//   },
//   {
//     id: "valasia-iakovoglou",
//     image: valasiaIakovoglou,
//     name: "Dr. Valasia Iakovoglou",
//     from: "USA",
//     about: "Iowa State University",
//     link: "/executive-panel-members/valasia-iakovoglou",
//   },
//   {
//     id: "vladlen-slepak",
//     image: vladlenSlepak,
//     name: "Dr. Vladlen Slepak",
//     from: "USA",
//     about: "University of Miami Miller School of Medicine",
//     link: "/executive-panel-members/vladlen-slepak",
//   },
//   {
//     id: "yong-xiao-wang",
//     image: yongXiaoWang,
//     name: "Dr. Yong Xiao Wang",
//     from: "USA",
//     about: "Albany Medical College",
//     link: "/executive-panel-members/yong-xiao-wang",
//   },
// ];

// export const panel_members = panel_members_about;

// export const john_maesaka_data = {
//   image: johnMaesaka,
//   name: "Dr. John K. Maesaka",
//   from: "NYU Grossman Long Island School of Medicine, USA",
//   about:
//     "John Maesaka, professor of medicine at NYU Grossman Long Island School of Medicine and Chief Emeritus, Division of Nephrology and Hypertension at the NYU Langone Hospital Long Island. He received a BA degree from Harvard University, MD from Boston University School of Medicine, and trained at Barnes Jewish Hospital, Mount Sinai Hospital, and Medical School N.Y. He spent 5 years in a physiology lab at Mount Sinai Medical Center which prepared him for his future research.",
//   banner: johnMaesaka_banner,
//   link: "/executive-panel-members/john-maesaka",
// };

// export const consolato_sergi_data = {
//   image: consolatoSergi,
//   name: "Dr. Consolato Sergi",
//   from: "University of Alberta and Ottawa, Canada",
//   about:
//     "Dr. Sergi is the Chief of the Anatomic Pathology Division at the Children’s Hospital of Eastern Ontario, and Professor of Pediatrics and Pathology at the University of Alberta and Ottawa, Canada. Canadian, born in Rome (Italy), he earned his MD with honors and a Pediatric Pathology Fellowship from the University of Genoa, Italy.",
//   banner: consolatoSergi_banner,
//   link: "/executive-panel-members/consolato-sergi",
// };

// export const saad_tayyab_data = {
//   image: saadTayyab,
//   name: "Dr. Saad Tayyab",
//   from: "UCSI University, Kuala Lumpur, Malaysia",
//   about:
//     "Dr. Saad Tayyab studied Biochemistry at Aligarh Muslim University, India, completing Masters and Ph.D. degrees in 1981 and 1987, respectively. He is currently working as a Professor of Pharmaceutical Chemistry at UCSI University, Kuala Lumpur, Malaysia. Before joining UCSI University, Dr. Saad served at Universiti Malaya (2004-2018), Haramaya University, Ethiopia (2001-2004), Aligarh Muslim University, India (1988-2001), and the University of Kashmir, India (1987-1988). He was admitted as a Fellow, Royal Society of Chemistry, UK, in 2017, Fellow, Royal Society of Biology, UK, in 2019, Member, American Chemical Society in 2020, and Member, Sigma Xi in 2024.  journals.",
//   banner: saadTayyab_banner,
//   link: "/executive-panel-members/saad-tayyab",
// };

// export const bernd_blobel_data = {
//   image: berndBlobel,
//   name: "Dr. Bernd Blobel",
//   from: "University of Magdeburg, Germany",
//   about:
//     "Dr. Bernd Blobel studied Mathematics, Technical Cybernetics and Electronics, Bio-Cybernetics, Physics, Medicine and Informatics at the University of Magdeburg and other universities in the former GDR. He received his PhD in Physics with a neurophysiological study. Furthermore, he performed the Habilitation (qualification as university professor) in Medicine and Informatics.",
//   banner: berndBlobel_banner,
//   link: "/executive-panel-members/bernd-blobel",
// };

// export const murray_moo_young_data = {
//   image: murrayMooYoung,
//   name: "Prof. Murray Moo-Young",
//   from: "University of Waterloo, Canada",
//   about:
//     "Distinguished Professor Emeritus at the University of Waterloo. Educated at London (PhD), Toronto (MSc), and Edinburgh (Postdoc). He’s received awards from ACS, AIMBE, IUPAC, UNESCO, and others for bioengineering research.",
//   banner: murrayMooYoung_banner,
//   link: "/executive-panel-members/murray-moo-young",
// };

// export const valasia_iakovoglou_data = {
//   image: valasiaIakovoglou,
//   name: "Dr. Valasia Iakovoglou",
//   from: "Iowa State University, USA",
//   about:
//     "Dr. Iakovoglou has 25+ years of global experience as an ecophysiologist. Expert in seedling production, biodiversity, climate change. She’s a reviewer/editor of over 25 journals and an IPCC reviewer.",
//   banner: valasiaIakovoglou_banner,
//   link: "/executive-panel-members/valasia-iakovoglou",
// };

// export const vladlen_slepak_data = {
//   image: vladlenSlepak,
//   name: "Dr. Vladlen Slepak",
//   from: "University of Miami Miller School of Medicine, USA",
//   about:
//     "Dr. Slepak studied Biology in Moscow and earned his PhD in Bioorganic Chemistry. He has published 80+ papers on G protein signaling. Professor at University of Miami since 1995.",
//   banner: vladlenSlepak_banner,
//   link: "/executive-panel-members/vladlen-slepak",
// };

// export const yong_xiao_wang_data = {
//   image: yongXiaoWang,
//   name: "Dr. Yong Xiao Wang",
//   from: "Albany Medical College, USA",
//   about:
//     "Full Professor since 2006. Holds MD, PhD, and postdoc training. Funded by NIH, AHA, ADA, and others. Published in Nature, PNAS, Circ Res, etc. Active on journal boards and scientific committees.",
//   banner: yongXiaoWang_banner,
//   link: "/executive-panel-members/yong-xiao-wang",
// };

// export const epms_details_map = {
//   "john-maesaka": john_maesaka_data,
//   "consolato-sergi": consolato_sergi_data,
//   "saad-tayyab": saad_tayyab_data,
//   "bernd-blobel": bernd_blobel_data,
//   "murray-moo-young": murray_moo_young_data,
//   "valasia-iakovoglou": valasia_iakovoglou_data,
//   "vladlen-slepak": vladlen_slepak_data,
//   "yong-xiao-wang": yong_xiao_wang_data,
// };




// // === Image Imports ===
// import antonioCarloGaloforo from "../../assets/Pannel Members/Antonio_Carlo_Galoforo.jpg";
// import joeSamRobinson from "../../assets/Pannel Members/Joe_Sam_Robinson.jpg";
// import juanMoreira from "../../assets/Pannel Members/Juan_Moreira.jpg";
// import kenWare from "../../assets/Pannel Members/Ken_Ware.jpg";
// import kennethBStorey from "../../assets/Pannel Members/Kenneth_B_Storey.jpg";
// import robertBSlocum from "../../assets/Pannel Members/Robert_B_Slocum.jpg";
// import sergeiMDanilov from "../../assets/Pannel Members/Sergei_M_Danilov.jpg";
// import wSElMasri from "../../assets/Pannel Members/W_S_El_Masri.jpg";
// import yongXiaoWang from "../../assets/Pannel Members/Yong_Xiao_Wang.jpg";
// import zhenhuanLiu from "../../assets/Pannel Members/Zhenhuan_Liu.jpg";

// import antonioCarloGaloforo_banner from "../../assets/Pannel Banners/Antonio_Carlo_Galoforo_banner.jpg";
// import joeSamRobinson_banner from "../../assets/Pannel Banners/Joe_Sam_Robinson_banner.jpg";
// import juanMoreira_banner from "../../assets/Pannel Banners/Juan_Moreira_banner.jpg";
// import kenWare_banner from "../../assets/Pannel Banners/Ken_Ware_banner.jpg";
// import kennethBStorey_banner from "../../assets/Pannel Banners/Kenneth_B_Storey_banner.jpg";
// import robertBSlocum_banner from "../../assets/Pannel Banners/Robert_B_Slocum_banner.jpg";
// import sergeiMDanilov_banner from "../../assets/Pannel Banners/Sergei_M_Danilov_banner.jpg";
// import wSElMasri_banner from "../../assets/Pannel Banners/W_S_El_Masri_banner.jpg";
// import yongXiaoWang_banner from "../../assets/Pannel Banners/Yong_Xiao_Wang_banner.jpg";
// import zhenhuanLiu_banner from "../../assets/Pannel Banners/Zhenhuan_Liu_banner.jpg";

// // === Individual Member Exports ===

// export const ken_ware_data = {
//   image: kenWare,
//   name: "Ken Ware",
//   from: "NeuroPhysics Therapy Institute and Research Centre, Australia",
//   about:
//     "Ken Ware is the founder of Neurotricional Sciences Pty Ltd and NeuroPhysics Therapy and Research. He has presented research at 35+ international science conferences and published in several peer-reviewed journals. He is a former Mr. Universe (1994) and recipient of the Queen’s Australian Sports Medal (2000).",
//   banner: kenWare_banner,
//   link: "/executive-panel-members/ken-ware",
// };

// export const joe_sam_robinson_data = {
//   image: joeSamRobinson,
//   name: "Joe Sam Robinson",
//   from: "Mercer University, United States",
//   about:
//     "President of the Georgia Neurosurgical Institute and Chief of Neurosurgery at Atrium Navicent and Mercer University. Harvard and University of Virginia alumnus with neurosurgical training from Northwestern. Published author and government advisor.",
//   banner: joeSamRobinson_banner,
//   link: "/executive-panel-members/joe-sam-robinson",
// };

// export const robert_b_slocum_data = {
//   image: robertBSlocum,
//   name: "Robert B Slocum",
//   from: "University of Kentucky HealthCare, United States",
//   about:
//     "Narrative Medicine Program Coordinator at University of Kentucky HealthCare. Holds doctorates in law, ministry, and theology. Author/co-editor of 14 books and 36+ articles. Interests include the clinical application of narrative and identity formation.",
//   banner: robertBSlocum_banner,
//   link: "/executive-panel-members/robert-b-slocum",
// };

// export const yong_xiao_wang_data = {
//   image: yongXiaoWang,
//   name: "Yong Xiao Wang",
//   from: "Albany Medical College, United States",
//   about:
//     "Professor at Albany Medical College since 2006. MD and PhD with postdoctoral training in Germany and the USA. Widely published and recognized in leading scientific journals. Active in editorial boards and scientific committees.",
//   banner: yongXiaoWang_banner,
//   link: "/executive-panel-members/yong-xiao-wang",
// };

// export const sergei_m_danilov_data = {
//   image: sergeiMDanilov,
//   name: "Sergei M Danilov",
//   from: "University of Illinois, United States",
//   about:
//     "PhD and postdoc from the National Cardiology Research Center, Moscow. Heads ACE biology lab at University of Illinois at Chicago. Published 200+ papers and serves on the editorial board of Biomedicines.",
//   banner: sergeiMDanilov_banner,
//   link: "/executive-panel-members/sergei-m-danilov",
// };

// export const juan_moreira_data = {
//   image: juanMoreira,
//   name: "Juan Moreira",
//   from: "Centro Neurointegrativo Gnosis, Puerto Rico",
//   about:
//     "Board-certified neurologist with two fellowships in vascular neurology and neuroimaging. Over 25 years in private practice. Expertise includes Botox, TMS, and Laser Photobiomodulation. Strong interest in clinical research.",
//   banner: juanMoreira_banner,
//   link: "/executive-panel-members/juan-moreira",
// };

// export const kenneth_b_storey_data = {
//   image: kennethBStorey,
//   name: "Kenneth B Storey",
//   from: "Carleton University, Canada",
//   about:
//     "Professor of Biochemistry and Canada Research Chair in Molecular Physiology. Author of over 1000 publications on biochemical adaptation, including hibernation and freeze tolerance. Recipient of the Flavelle and Fry medals.",
//   banner: kennethBStorey_banner,
//   link: "/executive-panel-members/kenneth-b-storey",
// };

// export const w_s_el_masri_data = {
//   image: wSElMasri,
//   name: "W S El Masri",
//   from: "Keele University, United Kingdom",
//   about:
//     "Honorary Clinical Professor of Spinal Injuries. Treated over 10,000 patients. Author of 145 manuscripts. Former president of international spinal societies and recipient of numerous awards.",
//   banner: wSElMasri_banner,
//   link: "/executive-panel-members/w-s-el-masri",
// };

// export const antonio_carlo_galoforo_data = {
//   image: antonioCarloGaloforo,
//   name: "Antonio Carlo Galoforo",
//   from: "University of Pavia, Italy",
//   about:
//     "Expert in oxygen and ozone therapy. Professor at University of Pavia and Unicamillus. WHO consultant, speaker, and author. Heads multiple therapy centers in Italy. President of O3FORAFRICA Onlus.",
//   banner: antonioCarloGaloforo_banner,
//   link: "/executive-panel-members/antonio-carlo-galoforo",
// };

// export const zhenhuan_liu_data = {
//   image: zhenhuanLiu,
//   name: "Zhenhuan Liu",
//   from: "Guangzhou University Chinese Medicine, China",
//   about:
//     "Professor of Pediatrics and pediatric acupuncturist. Treated over 40,000 children with neurological conditions. Published 268 papers and edited 10 books. Leading figure in integrated traditional Chinese and Western medicine.",
//   banner: zhenhuanLiu_banner,
//   link: "/executive-panel-members/zhenhuan-liu",
// };

// // === Panel Members About (Short List) ===

// export const panel_members_about = [
//   {
//     id: "ken-ware",
//     image: kenWare,
//     name: "Ken Ware",
//     from: "Australia",
//     about: "NeuroPhysics Therapy Institute and Research Centre",
//     link: "/executive-panel-members/ken-ware",
//   },
//   {
//     id: "joe-sam-robinson",
//     image: joeSamRobinson,
//     name: "Joe Sam Robinson",
//     from: "United States",
//     about: "Mercer University",
//     link: "/executive-panel-members/joe-sam-robinson",
//   },
//   {
//     id: "robert-b-slocum",
//     image: robertBSlocum,
//     name: "Robert B Slocum",
//     from: "United States",
//     about: "University of Kentucky HealthCare",
//     link: "/executive-panel-members/robert-b-slocum",
//   },
//   {
//     id: "yong-xiao-wang",
//     image: yongXiaoWang,
//     name: "Yong Xiao Wang",
//     from: "United States",
//     about: "Albany Medical College",
//     link: "/executive-panel-members/yong-xiao-wang",
//   },
//   {
//     id: "sergei-m-danilov",
//     image: sergeiMDanilov,
//     name: "Sergei M Danilov",
//     from: "United States",
//     about: "University of Illinois",
//     link: "/executive-panel-members/sergei-m-danilov",
//   },
//   {
//     id: "juan-moreira",
//     image: juanMoreira,
//     name: "Juan Moreira",
//     from: "Puerto Rico",
//     about: "Centro Neurointegrativo Gnosis",
//     link: "/executive-panel-members/juan-moreira",
//   },
//   {
//     id: "kenneth-b-storey",
//     image: kennethBStorey,
//     name: "Kenneth B Storey",
//     from: "Canada",
//     about: "Carleton University",
//     link: "/executive-panel-members/kenneth-b-storey",
//   },
//   {
//     id: "w-s-el-masri",
//     image: wSElMasri,
//     name: "W S El Masri",
//     from: "United Kingdom",
//     about: "Keele University",
//     link: "/executive-panel-members/w-s-el-masri",
//   },
//   {
//     id: "antonio-carlo-galoforo",
//     image: antonioCarloGaloforo,
//     name: "Antonio Carlo Galoforo",
//     from: "Italy",
//     about: "University of Pavia",
//     link: "/executive-panel-members/antonio-carlo-galoforo",
//   },
//   {
//     id: "zhenhuan-liu",
//     image: zhenhuanLiu,
//     name: "Zhenhuan Liu",
//     from: "China",
//     about: "Guangzhou University of Chinese Medicine",
//     link: "/executive-panel-members/zhenhuan-liu",
//   },
// ];

// // === Map of Panel Members by ID for Dynamic Routing ===
// export const epms_details_map = {
//   "ken-ware": ken_ware_data,
//   "joe-sam-robinson": joe_sam_robinson_data,
//   "robert-b-slocum": robert_b_slocum_data,
//   "yong-xiao-wang": yong_xiao_wang_data,
//   "sergei-m-danilov": sergei_m_danilov_data,
//   "juan-moreira": juan_moreira_data,
//   "kenneth-b-storey": kenneth_b_storey_data,
//   "w-s-el-masri": w_s_el_masri_data,
//   "antonio-carlo-galoforo": antonio_carlo_galoforo_data,
//   "zhenhuan-liu": zhenhuan_liu_data,
// };

// // === Full Array of Panel Members (Detailed View) ===
// export const panel_members = [
//   ken_ware_data,
//   joe_sam_robinson_data,
//   robert_b_slocum_data,
//   yong_xiao_wang_data,
//   sergei_m_danilov_data,
//   juan_moreira_data,
//   kenneth_b_storey_data,
//   w_s_el_masri_data,
//   antonio_carlo_galoforo_data,
//   zhenhuan_liu_data,
// ];



// === Image Imports ===
import antonioCarloGaloforo from "../../assets/Pannel Members/Antonio_Carlo_Galoforo.jpg";
import joeSamRobinson from "../../assets/Pannel Members/Joe_Sam_Robinson.jpg";
import juanMoreira from "../../assets/Pannel Members/Juan_Moreira.jpg";
import kenWare from "../../assets/Pannel Members/Ken_Ware.jpg";
import kennethBStorey from "../../assets/Pannel Members/Kenneth_B_Storey.jpg";
import robertBSlocum from "../../assets/Pannel Members/Robert_B_Slocum.jpg";
import sergeiMDanilov from "../../assets/Pannel Members/Sergei_M_Danilov.jpg";
import wSElMasri from "../../assets/Pannel Members/W_S_El_Masri.jpg";
import yongXiaoWang from "../../assets/Pannel Members/Yong_Xiao_Wang.jpg";
import zhenhuanLiu from "../../assets/Pannel Members/Zhenhuan_Liu.jpg";

import antonioCarloGaloforo_banner from "../../assets/Pannel Banners/Antonio_Carlo_Galoforo_banner.jpg";
import joeSamRobinson_banner from "../../assets/Pannel Banners/Joe_Sam_Robinson_banner.jpg";
import juanMoreira_banner from "../../assets/Pannel Banners/Juan_Moreira_banner.jpg";
import kenWare_banner from "../../assets/Pannel Banners/Ken_Ware_banner.jpg";
import kennethBStorey_banner from "../../assets/Pannel Banners/Kenneth_B_Storey_banner.jpg";
import robertBSlocum_banner from "../../assets/Pannel Banners/Robert_B_Slocum_banner.jpg";
import sergeiMDanilov_banner from "../../assets/Pannel Banners/Sergei_M_Danilov_banner.jpg";
import wSElMasri_banner from "../../assets/Pannel Banners/W_S_El_Masri_banner.jpg";
import yongXiaoWang_banner from "../../assets/Pannel Banners/Yong_Xiao_Wang_banner.jpg";
import zhenhuanLiu_banner from "../../assets/Pannel Banners/Zhenhuan_Liu_banner.jpg";

export const ken_ware_data = {
  image: kenWare,
  name: "Ken Ware",
  from: "NeuroPhysics Therapy Institute and Research Centre, Australia",
  about:
    "Ken Ware is the founder of Neurotricional Sciences Pty Ltd and NeuroPhysics Therapy and Research and he had been in private practice for almost 30 years, while doing independent and collaborative research. He also presented unique research at more than 35 major International Science Conferences including neuroscience, Physics, Psychology and Life Sciences, which covers a very broad scientific audience. He had published relative publications in ‘Frontiers in Clinical Physiology’ - ‘World Journal of Neuroscience’ – ‘World Journal of Cardiovascular diseases’ – ‘Journal of Behavioural and Brain Sciences’- ‘Complexity Science in Human Change’. He is Former Mr. Universe 1994, National powerlifting and Bodybuilding champion and record holder. He is recipient of Her Majesty, Queen Elizabeth’s’ ‘Australian Sports Medal’ - in 2000, in recognition for personal contributions to the development of the Australian Sporting Culture.",
  banner: kenWare_banner,
  link: "/executive-panel-members/ken-ware",
};

export const joe_sam_robinson_data = {
  image: joeSamRobinson,
  name: "Joe Sam Robinson",
  from: "Mercer University, United States",
  about:
    "Joe Sam Robinson is President of the Georgia Neurosurgical Institute and Chief of Neurosurgery at Atrium Navicent The Medical Center and Mercer University, all in Macon, Georgia. He is an alumnus of Harvard University and the University of Virginia Medical School. Dr. Robinson received his neurosurgical training at Northwestern University with rotations at the National Institute of Health and Sloan-Kettering Hospital, New York City. He has served on numerous government commissions, has widely published, and presented scientific papers in numerous academic locations.",
  banner: joeSamRobinson_banner,
  link: "/executive-panel-members/joe-sam-robinson",
};

export const robert_b_slocum_data = {
  image: robertBSlocum,
  name: "Robert B Slocum",
  from: "University of Kentucky HealthCare, United States",
  about:
    "Robert B. Slocum is the Narrative Medicine Program Coordinator at University of Kentucky HealthCare. He holds doctorates in law (Vanderbilt), ministry (University of the South), and theology (Marquette). He has experience in pastoral ministry as well as academic teaching and administration. He has taught undergraduate courses in religious studies and ethics. He is an Assistant Professor (voluntary faculty, Internal Medicine) at the University of Kentucky College of Medicine (COM). He teaches a fourth-year COM elective on the narrative basis for patient care and resilient practice. He is a member of the Hospital Ethics Committee. He is the author, editor, or co-editor of 14 books, including a journal of reflections. His 36 articles have appeared in theological or medical journals and as book chapters, and he has made presentations at more than two dozen theological and medical conferences. He has also published short fiction and poetry. He is interested in the clinical application of narrative and the significance of narrative for identity formation. He sees Narrative Medicine as a bridge between medical humanities and clinical practice.",
  banner: robertBSlocum_banner,
  link: "/executive-panel-members/robert-b-slocum",
};

export const yong_xiao_wang_data = {
  image: yongXiaoWang,
  name: "Yong Xiao Wang",
  from: "Albany Medical College, United States",
  about:
    "Dr. Yong-Xiao Wang has been a Full Professor in Department of Molecular and Cellular Physiology at Albany Medical College since 2006. Dr. Wang obtained his MD at Wannan Medical University, PhD at Fourth Military Medical University, and postdoctoral training at Technology University of Munich and University of Pennsylvania. He has made many important findings using complementary molecular, biochemical, physiological, and genetic approaches at the molecular, organelle, cellular, tissue and organism levels in animals and human samples, had numerous publications in Nature Commun (impact factor: 14.290), Antioxid Redox Signal (8.209), Proc Natl Acad Sci USA (9.432), Nature (34.480), Circ Res (9.214), and other highly peer-reviewed journals and academic books, and served as the editorial board member and/or section editor as well as the executive committee member and/or subcommittee chair for professional societies.",
  banner: yongXiaoWang_banner,
  link: "/executive-panel-members/yong-xiao-wang",
};

export const sergei_m_danilov_data = {
  image: sergeiMDanilov,
  name: "Sergei M Danilov",
  from: "University of Illinois, United States",
  about:
    "Sergei M. Danilov, MD completed his PhD and postdoctoral studies from the National Cardiology Research Center, Moscow, Russia. He is the Principal Investigator and Head of the laboratory of ACE biology in the Division of Pulmonary and Critical Care, (Department of Medicine in the University of Illinois at Chicago). His laboratory developed more than 40 mAbs to ACE. He has published more than 200 papers on ACE biology and ACE immmunochemistry in highly respected journals and has been serving as an editorial board member of Biomedicines.",
  banner: sergeiMDanilov_banner,
  link: "/executive-panel-members/sergei-m-danilov",
};

export const juan_moreira_data = {
  image: juanMoreira,
  name: "Juan Moreira",
  from: "Centro Neurointegrativo Gnosis, Puerto Rico",
  about:
    "Board-certified neurologist with two fellowships; vascular neurology and neuroimaging. Exceptional background with over 25 years of experience devoted to providing top quality healthcare at the hospital, ER and ambulatory setting. I have successfully run a private practice from 1995-to 2022. In addition, with experience on Botox, Transcranial Magnetic Stimulation and Laser Photobiomodulation. Interested on clinical research. Looking to work on an institution dedicated to excellence.Board-certified neurologist with two fellowships; vascular neurology and neuroimaging. Exceptional background with over 25 years of experience devoted to providing top quality healthcare at the hospital, ER and ambulatory setting. I have successfully run a private practice from 1995-to 2022. In addition, with experience on Botox, Transcranial Magnetic Stimulation and Laser Photobiomodulation. Interested on clinical research. Looking to work on an institution dedicated to excellence.",
  banner: juanMoreira_banner,
  link: "/executive-panel-members/juan-moreira",
};

export const kenneth_b_storey_data = {
  image: kennethBStorey,
  name: "Kenneth B Storey",
  from: "Carleton University, Canada",
  about:
    "Ken Storey, PhD, FRSC, is a Professor of Biochemistry at Carleton University in Ottawa and holds the Canada Research Chair in Molecular Physiology. He graduated from University of Calgary (BSc 1971) and University of British Columbia (PhD 1974). Ken’s field of interest is biochemical adaptation; in particular, mammalian hibernation and freeze tolerance are core topics in his over 1000 refereed publications. Ken won the 2010 Flavelle medal from the Royal Society of Canada , “CryoFellow” of the CryoBiology Society in 2012 and the 2011 Fry medal from the Canadian Society of Zoologists.",
  banner: kennethBStorey_banner,
  link: "/executive-panel-members/kenneth-b-storey",
};

export const w_s_el_masri_data = {
  image: wSElMasri,
  name: "W S El Masri",
  from: "Keele University, United Kingdom",
  about:
    "Prof W S El Masri FRCS Ed, FRCP currently Hon. Clinical Professor of Spinal Injuries (SI), Keele University has trained between 1971 & 1983 in the Oxford group of hospitals, Guys & Stoke Mandeville hospitals and the USA. He obtained the first accreditation in Spinal Injuries and General Surgery in 1982. Appointed Consultant Surgeon in Spinal Injuries at the Midland Centre for Spinal Injuries in 1983. He personally treated 10,000 patients with. He published 145 manuscripts. He the author of the: Concepts of “Physiological Instability of the Spinal Cord”, “Time related Biomechanical Instability”, “Micro-instability of the injured spine” and published the largest series of Bladder cancer in SCI patients. He has repeatedly demonstrated and published on the discrepancy between the radiological and neurological presentation of patients in support of the hypothesis that the initial force of the impact and the quality of the management of both the injured spine and the effects of cord injury are the two majpr determinants of the initial neurological loss and the neurological outcome. He is Past-President of the International Spinal Cord Society; Past Chairman British Association of Spinal Cord Injury Specialists and has lectured world-wide. He won many National and International awards.",
  banner: wSElMasri_banner,
  link: "/executive-panel-members/w-s-el-masri",
};

export const antonio_carlo_galoforo_data = {
  image: antonioCarloGaloforo,
  name: "Antonio Carlo Galoforo",
  from: "University of Pavia, Italy",
  about:
    "Prof. Antonio Carlo Galoforo graduated in Medicine and Surgery in Brescia, one of the most accredited experts in oxygen and ozone therapy, of which he has been a member of the Scientific Society since 1992. Head of oxygen ozone therapy at excellent polyclinics where he works daily and contact person for the Lombardy Region for hearings on the use of ozone in medicine and the environment. Speaker at various national and international conferences. Author of numerous national and international works, Master Professor in oxygen ozone therapy at the University of Pavia and Unicamillus International Medical University in Rome. He is reference person accredited by the WHO for studies relating to the use of Ozone for Buruli Ulcer treatment; Founder and President of O3FORAFRICA Onlus; Head of Oxygen Ozone Therapy of Affidea Italia Centers and Bianalisi Group; Academician of European Academy for Economic and Cultural Relations. Winner of two Research Projects from Minister of Health",
  banner: antonioCarloGaloforo_banner,
  link: "/executive-panel-members/antonio-carlo-galoforo",
};

export const zhenhuan_liu_data = {
  image: zhenhuanLiu,
  name: "Zhenhuan Liu",
  from: "Guangzhou University of Chinese Medicine, China",
  about:
    "Zhenhuan LIU professor of pediatrics,Pediatric acupuncturist Ph.D.tutor.He has been engaged in pediatric clinical and child rehabilitation for 40 years. Led the rehabilitation team to treat more than 40,000 cases of children with intellectual disability, cerebral palsy and autism from China and more than 20 countries,More than 26800 childrens deformity returned to school and society and became self-sufficient.The rehabilitation effect ranks the international advanced level.Vice-chairman of Rehabilitation professional committe children with cerebral palsy,World Federation of Chinese Medicine Societies.Visiting Profassor of Chinese University of Hong Kong in recent 10 years. .He is most famous pediatric neurological and rehabilitation specialists in integrated traditional Chinese and Western medicine in China.He has edited 10 books.He has published 268 papers in international and Chinese medical journals.",
  banner: zhenhuanLiu_banner,
  link: "/executive-panel-members/zhenhuan-liu",
};
// === Panel Members About (Short List, mirroring commented code's structure) ===
export const panel_members_about = [
  {
    id: "ken-ware",
    image: kenWare,
    name: "Ken Ware",
    from: "Australia",
    about: "NeuroPhysics Therapy Institute and Research Centre",
    link: "/executive-panel-members/ken-ware",
  },
  {
    id: "joe-sam-robinson",
    image: joeSamRobinson,
    name: "Joe Sam Robinson",
    from: "United States",
    about: "Mercer University",
    link: "/executive-panel-members/joe-sam-robinson",
  },
  {
    id: "robert-b-slocum",
    image: robertBSlocum,
    name: "Robert B Slocum",
    from: "United States",
    about: "University of Kentucky HealthCare",
    link: "/executive-panel-members/robert-b-slocum",
  },
  {
    id: "yong-xiao-wang",
    image: yongXiaoWang,
    name: "Yong Xiao Wang",
    from: "United States",
    about: "Albany Medical College",
    link: "/executive-panel-members/yong-xiao-wang",
  },
  {
    id: "sergei-m-danilov",
    image: sergeiMDanilov,
    name: "Sergei M Danilov",
    from: "United States",
    about: "University of Illinois",
    link: "/executive-panel-members/sergei-m-danilov",
  },
  {
    id: "juan-moreira",
    image: juanMoreira,
    name: "Juan Moreira",
    from: "Puerto Rico",
    about: "Centro Neurointegrativo Gnosis",
    link: "/executive-panel-members/juan-moreira",
  },
  {
    id: "kenneth-b-storey",
    image: kennethBStorey,
    name: "Kenneth B Storey",
    from: "Canada",
    about: "Carleton University",
    link: "/executive-panel-members/kenneth-b-storey",
  },
  {
    id: "w-s-el-masri",
    image: wSElMasri,
    name: "W S El Masri",
    from: "United Kingdom",
    about: "Keele University",
    link: "/executive-panel-members/w-s-el-masri",
  },
  {
    id: "antonio-carlo-galoforo",
    image: antonioCarloGaloforo,
    name: "Antonio Carlo Galoforo",
    from: "Italy",
    about: "University of Pavia",
    link: "/executive-panel-members/antonio-carlo-galoforo",
  },
  {
    id: "zhenhuan-liu",
    image: zhenhuanLiu,
    name: "Zhenhuan Liu",
    from: "China",
    about: "Guangzhou University of Chinese Medicine",
    link: "/executive-panel-members/zhenhuan-liu",
  },
];

// === Map of Panel Members by ID for Dynamic Routing ===
export const epms_details_map = {
  "ken-ware": ken_ware_data,
  "joe-sam-robinson": joe_sam_robinson_data,
  "robert-b-slocum": robert_b_slocum_data,
  "yong-xiao-wang": yong_xiao_wang_data,
  "sergei-m-danilov": sergei_m_danilov_data,
  "juan-moreira": juan_moreira_data,
  "kenneth-b-storey": kenneth_b_storey_data,
  "w-s-el-masri": w_s_el_masri_data,
  "antonio-carlo-galoforo": antonio_carlo_galoforo_data,
  "zhenhuan-liu": zhenhuan_liu_data,
};

// === Full Array of Panel Members (Detailed View), now referencing the short list ===
export const panel_members = panel_members_about;